module.exports = __webpack_public_path__ + "static/media/connectwise_manage_logo.9a17c7d9.png";